export default "/images/close.svg?365d620356109817775830bf5cbb8edd";